import GetHeadlessDelivery from './HeadlessDeliveryDef';

export default { GetHeadlessDelivery };
